import React from 'react';
import Instructor from '../../components/Instructor';

const InstrutorModule = () => {
	return (
		<>
			<Instructor />
		</>
	);
};

export default InstrutorModule;
